export const EarthenHuesDark = () => ({
	backgroundDefault: '#42352B',
	backgroundPrimary: '#544538',
	backgroundPrimary60: '#39312D',
	backgroundSecondary: '#2E251E',
});
